import React, { useState } from 'react';


export default function AppCreateEditform ({ onClosed })  {
    const [isVisible, setIsVisible] = useState(true);

    const handleCloseEdit = () => {
        setIsVisible(false);
        onClosed();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleCloseEdit();
    };
    return isVisible ? (
        <>
            <div className="flex justify-center ">
                {/* edit App Created */}
                <div className="popup-form">
                    <div className="w-full  flex items-center justify-center">
                        <div className="bg-white p-4 rounded-md shadow-md  py-3 px-1 lg:py-3 xl:py-3 2xl:p-4  w-fit">
                        <div className="lg:w-[250px] xl:w-[270px] 2xl:w-[380px] items-center justify-center">
                                <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl ">
                                    Edit  User
                                </div>
                                <hr className="mt-1 " />

                                <form onSubmit={handleSubmit}>
                                <div className="flex flex-col justify-center items-center ">
                                        <div className="flex py-3 justify-end items-center">
                                            <label
                                                htmlFor="yourInput"
                                                className="flex items-end px-3"
                                            >
                                                Name:<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="yourInput"
                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                style={{ width: '163px', textAlign: 'center' }}
                                                placeholder="Text"
                                                required
                                            />
                                        </div>
                                        <div className="flex py-3 justify-end items-center">
                                            <label
                                                htmlFor="yourInput"
                                                className="flex items-end px-3"
                                            >
                                                Phone :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input
                                                type="tel"
                                                id="yourInput"
                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                style={{ width: '163px', textAlign: 'center' }}
                                                placeholder="Number"
                                                required
                                            />
                                        </div>
                                        <div className="flex py-3 justify-end items-center">
                                            <label
                                                htmlFor="yourInput"
                                                className="flex items-end px-3"
                                            >
                                                Email :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="yourInput"
                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                style={{ width: '163px', textAlign: 'center' }}
                                                placeholder="email"
                                                required
                                            />
                                        </div>
                                        <div className="flex py-3 justify-end items-center">
                                            <label
                                                htmlFor="yourInput"
                                                className="flex items-end px-3"
                                            >
                                                Coupon Used :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="yourInput"
                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                style={{ width: '163px', textAlign: 'center' }}
                                                placeholder="email"
                                                required
                                            />
                                        </div>
                                        

                                        <div className="flex py-3 justify-end items-center">
                                            <label
                                                htmlFor="yourInput"
                                                className="flex items-end px-3"
                                            >
                                                Created By :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="yourInput"
                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                style={{ width: '163px', textAlign: 'center' }}
                                                placeholder="Super Admin (Auto)"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="button-container flex justify-center p-1 space-x-12 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                            <button
                                                type="button"
                                                onClick={handleCloseEdit}
                                                className=" bg-white px-3 py-1 flex-shrink-0 shadow-md"
                                                style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="px-3 py-1 flex-shrink-0 "
                                                style={{
                                                    background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                                }}
                                            >
                                                Save
                                            </button>

                                        </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    ) : null
}
